import { client } from './api';

class TagsService {
  getTags = async () => {
    const response = await client.get('tag');
    return response;
  };
}

export default new TagsService();
